import { render, staticRenderFns } from "./Activities.vue?vue&type=template&id=42856690&scoped=true&"
import script from "./Activities.vue?vue&type=script&lang=js&"
export * from "./Activities.vue?vue&type=script&lang=js&"
import style0 from "./Activities.vue?vue&type=style&index=0&id=42856690&prod&lang=scss&scoped=true&"
import style1 from "./Activities.vue?vue&type=style&index=1&id=42856690&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42856690",
  null
  
)

export default component.exports